import React from 'react';
import { PRESETS } from './presets';
import MetricRegistry from './registry/MetricRegistry';

const PresetSelector = ({ appliedPreset, onApplyPreset, onReset }) => {
  const handlePresetChange = (e) => {
    const presetId = e.target.value;
    if (!presetId) {
      onApplyPreset(null, null); // null cards = keep current
      return;
    }
    const preset = PRESETS.find((p) => p.id === presetId);
    if (preset) {
      const validIds = preset.metricIds.filter((id) => id in MetricRegistry);
      onApplyPreset(presetId, validIds);
    }
  };

  return (
    <div className="flex items-center gap-3 mb-4">
      <label htmlFor="preset-select" className="text-sm text-lightgray">
        Preset:
      </label>
      <select
        id="preset-select"
        value={appliedPreset || ''}
        onChange={handlePresetChange}
        className="bg-deepblue text-lightgray border border-lightblue rounded px-3 py-1.5 text-sm"
      >
        <option value="">Custom</option>
        {PRESETS.map((p) => (
          <option key={p.id} value={p.id}>{p.label}</option>
        ))}
      </select>
      <button
        onClick={onReset}
        className="text-sm text-orange hover:underline"
      >
        Reset to Defaults
      </button>
    </div>
  );
};

export default PresetSelector;
